import {
    AbstractControl,
    NG_VALIDATORS,
    ValidationErrors,
    Validator,
} from '@angular/forms';
import { Directive } from '@angular/core';

export function ValidateNotEmptyInput(control: AbstractControl): { [key: string]: any } | null {
    let input = control.value;
    let regExp = new RegExp('^([ ]*[^ ]+[ ]?)+[ ]*$');

    let isValid = regExp.test(input);

    if (input && !isValid) {
        return { 'nameInvalid': true };
    }
    return null;
}

@Directive({
    selector: '[not-empty]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: NotEmptyInputValidator,
            multi: true
        }
    ]
})
export class NotEmptyInputValidator implements Validator {
    validate(control: AbstractControl): ValidationErrors | null {
        return ValidateNotEmptyInput(control);
    }
}